export const ViaConviteKeys = {
  Promotor: 'PROMOTOR',
  CodigoAutocaptura: 'CODIGOAUTOCAPTURA',
  Email: 'EMAIL',
};
